import React, { useState, useEffect } from 'react';

/**
 * مكون صورة محسّن بشكل كامل لتحسين الأداء
 * يشمل: lazy loading, dimensions, preloading للصور المهمة
 * يدعم الآن Backend Image Optimization (اختياري)
 */
function OptimizedImage({
    src,
    alt = '',
    width,
    height,
    priority = false,
    style = {},
    className = '',
    useOptimizer = false, // Set to true after deploying backend changes
    objectFit = 'cover',
    aspectRatio = null
}) {
    const [imgSrc, setImgSrc] = useState(src);

    useEffect(() => {
        if (useOptimizer && src && width) {
            // Logic to construct optimized URL
            // We need to extract the path relative to public folder or uploads
            let path = src;
            if (src.includes('backend/')) {
                path = src.split('backend/')[1];
            }

            // Construct new URL pointing to our new controller
            // Note: This requires the backend changes to be deployed to staging
            const optimizedUrl = `https://staging.via-app.ca/via_api/image/optimize?path=${path}&w=${width}&q=80`;
            setImgSrc(optimizedUrl);
        } else {
            setImgSrc(src);
        }
    }, [src, width, useOptimizer]);

    if (!src) return null;

    const loading = priority ? 'eager' : 'lazy';
    const fetchPriority = priority ? 'high' : 'auto';

    // جمع الـ styles
    const combinedStyles = {
        objectFit,
        ...(aspectRatio && { aspectRatio }),
        ...style
    };

    return (
        <img
            src={imgSrc}
            alt={alt}
            width={width}
            height={height}
            loading={loading}
            fetchPriority={fetchPriority}
            decoding="async"
            className={className}
            style={combinedStyles}
        />
    );
}

export default OptimizedImage;
